import React from "react";

const DEFAULT_PRODUCT = '/defaults/default-product.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_PRODUCT; };

function ProductBanner({ sliderProducts = [] }) {
  return (
    <div className="et-l et-l--body">
      <div className="et_builder_inner_content et_pb_gutters3">
        <div className="et_pb_section et_pb_section_0_tb_body et_section_regular">
          <div className="et_pb_row et_pb_row_0_tb_body">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_text et_pb_text_0_tb_body et_pb_text_align_center et_pb_bg_layout_light">
                <div className="et_pb_text_inner">
                  <h1>Our Products</h1>
                  <p>Explore our range of products</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {sliderProducts.length > 0 && (
          <div className="et_pb_section et_pb_section_1_tb_body et_section_regular">
            <div className="et_pb_row et_pb_row_1_tb_body">
              <div className="et_pb_column et_pb_column_4_4 et_pb_column_1_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
                  {sliderProducts.map((item, i) => {
                    const imgPath = item.thumbnail || item.thubmnail;
                    return (
                      <div key={i} className="product-card" style={{
                        borderRadius: '10px',
                        overflow: 'hidden',
                        backgroundColor: '#1a1a2e',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                        textAlign: 'center'
                      }}>
                        {imgPath ? (
                          <img decoding="async" src={`${process.env.REACT_APP_API_URL}/storage/${imgPath}`} alt={item.name || ''} style={{ width: '100%', height: '200px', objectFit: 'cover' }} onError={handleImgError} />
                        ) : (
                          <img decoding="async" src={DEFAULT_PRODUCT} alt={item.name || 'Product'} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                        )}
                        <div style={{ padding: '15px' }}>
                          {item.name && <h3 className="yellow-color">{item.name}</h3>}
                          {item.link && <div style={{ color: '#ccc' }} dangerouslySetInnerHTML={{ __html: item.link }} />}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductBanner;
